import models from './models'
import pages from './pages'
import actions from './actions'

export default {
	models,
	pages,
	actions,
}
